// JSON requests to endpoints the generated client cannot type: `/api/me` before row S44 lands
// in the spec, and the catalog's workflow endpoints, whose `WorkflowDto`/`WorkflowBody` schema
// names collide with the legacy workflow's in openapi.json (the spec keeps the legacy shapes).
// Same session rules as the client: the CSRF header on every request, auth hints reported.
import { reportAuthHint } from "./client";
import { ApiError } from "./queries";

export type Method = "GET" | "POST" | "PUT" | "DELETE";

/** The parsed JSON body, or undefined for a 204. Throws ApiError for anything but 2xx. */
export async function requestJson(method: Method, path: string, body?: unknown): Promise<unknown> {
  const headers: Record<string, string> = { "X-OCS-CSRF": "1" };
  if (body !== undefined) headers["Content-Type"] = "application/json";
  let response: Response;
  try {
    response = await globalThis.fetch(new URL(path, typeof location !== "undefined" ? location.origin : "http://ocs.invalid"), {
      method,
      headers,
      body: body === undefined ? undefined : JSON.stringify(body),
      credentials: "same-origin",
    });
  } catch (e) {
    throw new ApiError(0, e instanceof Error ? e.message : e);
  }
  reportAuthHint(response);
  const text = await response.text();
  if (!response.ok) throw new ApiError(response.status, errorBody(text));
  return text ? (JSON.parse(text) as unknown) : undefined;
}

function errorBody(text: string): unknown {
  try {
    return JSON.parse(text) as unknown;
  } catch {
    return text;
  }
}
